import { LCWork } from "@libry-content/integrations";
import { normalizeIsbn } from "@libry-content/common";
import { VariantState } from "./useCurrentVariantUrlState";

//Get the most relevant variant of a work, based on current variant state.
//The priority is:
//If isbn or manifestationId is defined in state, find variant with corresponding triple
//If language, type and / or externalContentService is defined in state, get first variant corresponding with them (variant has to match all the defined variables from this selection)
//If no variant match is found based on parameters, get first variant from array
export const getCurrentVariantFromState = ({
  work,
  currentVariantState,
}: {
  work: LCWork;
  currentVariantState?: VariantState;
}) => {
  const variants = work.getVariantsWithTriples();

  const variantFromIsbnOrManifestationId = variants.find((variant) =>
    variant.workTriples.find((workTriple) => {
      if (currentVariantState?.manifestationId)
        return workTriple.manifestationId === currentVariantState.manifestationId;
      if (currentVariantState?.isbn)
        return workTriple.isbns.find((isbn) => normalizeIsbn(isbn) === normalizeIsbn(currentVariantState.isbn));
      return undefined;
    })
  );

  if (variantFromIsbnOrManifestationId) return variantFromIsbnOrManifestationId;

  const specifiedVariant = work.getSpecifiedVariantWithTriples({
    languagesSignature: currentVariantState?.language,
    documentTypeSignature: currentVariantState?.type,
    externalContentServiceOriginSignature: currentVariantState?.externalContentService,
  });

  return specifiedVariant ?? variants[0];
};
